import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons'

import {
  Pagination as BasePagination,
  PaginationPropsType,
} from '@monorepo/components/common'
import { IPagination } from '@monorepo/interfaces'

type PropsType = Partial<PaginationPropsType> & {
  meta: IPagination
  // totalPages: number
  pageRangeDisplayed?: number
  marginPagesDisplayed?: number
}

export const Pagination: React.FC<PropsType> = ({ meta, ...props }) => (
  <BasePagination
    {...props}
    meta={meta}
    containerClassName="pagination"
    activeClassName="active"
    pageClassName="page-item"
    pageLinkClassName="page-link"
    previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
    previousClassName="page-item"
    previousLinkClassName="page-link"
    nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
    nextClassName="page-item"
    nextLinkClassName="page-link"
    breakLabel="&nbsp;"
    breakClassName="page-item page-item--dots"
    breakLinkClassName="pagination__dots"
    // totalPages={meta.totalPages}
  />
)
